<h1>Maintenance</h1>

<h3>Database Index Fragmentation</h3>

@if (!indexFragmentation()) {
  <mat-spinner></mat-spinner>
}

@if (indexFragmentation()) {
  <div>
    <table mat-table [dataSource]="indexFragmentation().indexFragmentations">
      <ng-container matColumnDef="schema">
        <th mat-header-cell *matHeaderCellDef>Schema</th>
        <td mat-cell *matCellDef="let element">{{ element.schema }}</td>
      </ng-container>
      <ng-container matColumnDef="table">
        <th mat-header-cell *matHeaderCellDef>Table</th>
        <td mat-cell *matCellDef="let element">{{ element.table }}</td>
      </ng-container>
      <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef>Index</th>
        <td mat-cell *matCellDef="let element">{{ element.index }}</td>
      </ng-container>
      <ng-container matColumnDef="fragmentation">
        <th mat-header-cell *matHeaderCellDef>Fragmentation</th>
        <td mat-cell *matCellDef="let element">{{ element.fragmentation | number : '0.2-2' }} %</td>
      </ng-container>
      <ng-container matColumnDef="pageCount">
        <th mat-header-cell *matHeaderCellDef>Page Count</th>
        <td mat-cell *matCellDef="let element">{{ element.pageCount }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['schema', 'table', 'index', 'fragmentation', 'pageCount']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['schema', 'table', 'index', 'fragmentation', 'pageCount']"></tr>
    </table>
  </div>
}

<button mat-raised-button [disabled]="inFlight()" (click)="refreshIndexFragmentation()" i18n>Refresh</button>
<button mat-raised-button [disabled]="inFlight()" color="primary" (click)="scheduleIndexRebuild()" i18n>Schedule Index Rebuild</button>
